import { createContext, useContext, useState, type ReactNode } from "react";

export type AttributionWindow = "account_default" | "1d_click" | "7d_click" | "28d_click" | "1d_view" | "7d_view" | "7d_click_1d_view";

interface DashboardAttributionContextType {
  attributionWindow: AttributionWindow;
  setAttributionWindow: (w: AttributionWindow) => void;
  windowLabel: string;
}

const LABELS: Record<AttributionWindow, string> = {
  "account_default": "Account settings",
  "1d_click": "1-day click",
  "7d_click": "7-day click",
  "28d_click": "28-day click",
  "1d_view": "1-day view",
  "7d_view": "7-day view",
  "7d_click_1d_view": "7-day click, 1-day view",
};

const DashboardAttributionContext = createContext<DashboardAttributionContextType | null>(null);

export function DashboardAttributionProvider({ children }: { children: ReactNode }) {
  const [attributionWindow, setAttributionWindow] = useState<AttributionWindow>("account_default");

  return (
    <DashboardAttributionContext.Provider
      value={{ attributionWindow, setAttributionWindow, windowLabel: LABELS[attributionWindow] }}
    >
      {children}
    </DashboardAttributionContext.Provider>
  );
}

export function useDashboardAttribution() {
  const ctx = useContext(DashboardAttributionContext);
  if (!ctx) throw new Error("useDashboardAttribution must be used within DashboardAttributionProvider");
  return ctx;
}

export function useDashboardAttributionSafe() {
  return useContext(DashboardAttributionContext);
}
